import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { headVariants, staggerContainer, fadeIn } from "../useful/motion";

const Head = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = "https://static.igem.wiki/teams/4888/wiki/3d48c.png";
    img.onload = () => {
      setImageLoaded(true);
    };
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={`relative z-7 headpage`}>
      <div style={{ flex: 2 }}>
        {imageLoaded && (
          <motion.div
            variants={headVariants}
            initial="hidden"
            whileInView="show"
            className={`relative biglogo`}
          >
            <img
              src="https://static.igem.wiki/teams/4888/wiki/3d48c.png"
              alt="48C"
            />
          </motion.div>
        )}
      </div>
      <div className="bigtitle" style={{ flex: 1 }}>
        {imageLoaded && (
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.25 }}
            className={`relative`}
          >
            <motion.p
              variants={fadeIn("up", "tween", 0.2, 1)}
              className="relative headtitle"
            >
              CADMIUM
            </motion.p>
            <motion.p
              variants={fadeIn("up", "tween", 0.2, 1)}
              className="relative headtitle"
            >
              CATCHER
            </motion.p>
            <motion.p
              variants={fadeIn("up", "tween", 0.2, 1)}
              className="relative headtitle"
            >
              LBP*
            </motion.p>
          </motion.div>
        )}
      </div>
      <div className="gradient-02 z-0" />
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.25 }}
        className={`definitionhome deplacement`}
      >
        <motion.p variants={fadeIn("up", "tween", 0.2, 1)}>
          *Live Biotherapeutic Product
        </motion.p>
      </motion.div>
    </section>
  );
};

export default Head;
